import {
  useAppDispatch,
  useAppSelector,
} from '../../../../../../../redux/hooks';
import { cohortConfigTypeSelector } from '../../../../../../../redux/selectors/builder';
import { setCohortRowTimeToConvertTimeUnit } from '../../../../../../../redux/slices/oldBuilder';
import { getCapitalizedTimeUnitText } from '../../../../../../../utils';
import {
  SimpleCohortTypeKey,
  TimeUnit,
} from '../../../../../../../utils/apollo/graphqlSchema';
import { assertCondition } from '../../../../../../../utils/types';
import SingleSelectMenu from '../../../../../../Dropdown/SingleSelectMenu';
import { useCohortRowContext } from '../../../CohortRowContext';
import { CohortRowOperators } from '../../../CohortRowOperators';

const TimeToConvertCohort = () => {
  const dispatch = useAppDispatch();
  const { cohortRow, rowMeta } = useCohortRowContext();
  const { simpleCohortTypeKey, timeToConvert } = cohortRow;
  assertCondition(simpleCohortTypeKey === SimpleCohortTypeKey.Funnel);
  const cohortConfig = useAppSelector((state) =>
    cohortConfigTypeSelector(state, simpleCohortTypeKey),
  );
  assertCondition(cohortConfig.__typename === 'FunnelCohortConfig');
  const ttcConfig = cohortConfig.ttcConfig;
  const options = ttcConfig.timeUnits.map((timeUnit) => ({
    text: getCapitalizedTimeUnitText(timeUnit).plural,
    value: timeUnit,
  }));

  const handleChange = (timeUnit: string) => {
    dispatch(
      setCohortRowTimeToConvertTimeUnit({
        rowMeta,
        newValue: timeUnit as TimeUnit,
      }),
    );
  };

  return (
    <>
      <CohortRowOperators />
      <SingleSelectMenu
        options={options}
        value={timeToConvert?.timeUnit}
        onChange={handleChange}
      />
    </>
  );
};

export default TimeToConvertCohort;
